// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropPanel__container-e68ecf {
  position: absolute;
  z-index: 1;
  top: 24px;
  inset-inline-start: 24px;
  inset-inline-end: 24px;
  bottom: 24px;
  background: var(--base-0);
  border: 1px solid var(--base-30);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.DropPanel__icon-ec2383 {
  margin-bottom: 8px;
  width: 136px;
  height: 136px;
  fill: var(--brand-primary-40);
}

.DropPanel__container-e68ecf:before {
  position: absolute;
  content: "";
  inset-inline-start: 24px;
  inset-inline-end: 24px;
  top: 24px;
  bottom: 24px;
  border: 2px dashed var(--base-50);
  border-radius: 8px;
}

.DropPanel__dragging-fa1c04:before {
  border-color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatDragDrop/DropPanel/DropPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;AACF;;AAEA;EACE,qCAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  z-index: 1;\n  top: 24px;\n  inset-inline-start: 24px;\n  inset-inline-end: 24px;\n  bottom: 24px;\n  background: var(--base-0);\n  border: 1px solid var(--base-30);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.icon {\n  margin-bottom: 8px;\n  width: 136px;\n  height: 136px;\n  fill: var(--brand-primary-40);\n}\n\n.container:before {\n  position: absolute;\n  content: '';\n  inset-inline-start: 24px;\n  inset-inline-end: 24px;\n  top: 24px;\n  bottom: 24px;\n  border: 2px dashed var(--base-50);\n  border-radius: 8px;\n}\n\n.dragging:before {\n  border-color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DropPanel__container-e68ecf`,
	"icon": `DropPanel__icon-ec2383`,
	"dragging": `DropPanel__dragging-fa1c04`
};
module.exports = ___CSS_LOADER_EXPORT___;
